import { useCartContext } from '@mercadoni/sinister/dist/cjs/cart'
import { useMessages } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { useEffect } from 'react'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
const IGNORABLE_ERROR_REASONS = ['FLEET_WITH_DEFAULT_DEPARTMENT_NOT_FOUND']

const useCartStatusWatcher = () => {
  const { cartStatus } = useCartContext()
  const { errorCodes } = getLocale() || defaultLocale
  const cartError = cartStatus.hasErrors()

  const { onErrorMsg } = useMessages()
  useEffect(() => {
    if (cartError) {
      const ignoreReason = IGNORABLE_ERROR_REASONS.includes(
        cartError.error.reason
      )
      if (cartError.code === 'ERROR' && !ignoreReason) {
        const { error = {} } = cartError
        const msg = errorCodes[error.reason] || errorCodes.generic
        if (msg) {
          onErrorMsg(msg)
        }
      }
      // fake success
      cartStatus.setSuccess()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartError?.error])
}

export default useCartStatusWatcher
